<template>

    <el-form ref="form"  label-width="100px" size="mini">

        <el-form-item  :label="$t('report_grid_lines')">
            <el-switch v-model="gridline" @change="setgridline"></el-switch>
        </el-form-item>
        <el-form-item  :label="$t('report_row_and_column_number')">
            <el-switch v-model="headerVisible" @change="setheaderVisible"></el-switch>
        </el-form-item>
        <el-form-item  :label="$t('report_tab')">
            <el-switch v-model="tabStripVisible" @change="settabStripVisible"></el-switch>
        </el-form-item>
        <el-form-item  label="cellFormatter">
            <el-select v-model="fmtItem" filterable allow-create :placeholder="$t('form_please_select')" @change="setFormatter">
                <el-option
                        class="select_item"
                        v-for="item in fmtList"
                        :label="item"
                        :value="item">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form ref="chart" v-if="chartObj"  label-width="100px" size="mini">

            <el-form-item  label="chartType">
                <el-input  v-model="cType" @change="setChart('type')"  />
            </el-form-item>
            <el-form-item  label="chartText">
                <el-input  v-model="cTitle" @change="setChart('title')"  />
            </el-form-item>
            <el-form-item  label="Orientation">
                <el-switch v-model="cDataOrientation" @change="setChart('DataOrientation')"></el-switch>

            </el-form-item>

        </el-form>
        <el-form ref="table" v-if="tableObj"  label-width="100px" size="mini">
            <el-form-item  label="name">
                <el-input  v-model="tableName" @change="setTable('name')"  />
            </el-form-item>
            <el-form-item  label="Header">
                <el-switch v-model="showHeader" @change="setTable('header')"></el-switch>

            </el-form-item>
            <el-form-item  label="Footer">
                <el-switch v-model="showFooter" @change="setTable('footer')"></el-switch>

            </el-form-item>
            <el-form-item  label="Filter">
                <el-switch v-model="allowFilter" @change="setTable('filter')"></el-switch>

            </el-form-item>
            <el-form-item  label="Computer">
                <el-switch v-model="footerDropDownList" @change="setTable('fdpl')"></el-switch>
            </el-form-item>
            <el-form-item  label="resize">
                <el-switch v-model="showResize" @change="setTable('resize')"></el-switch>

            </el-form-item>
            <el-form-item  label="tableStyle">


                <el-select v-model="styleType" :placeholder="$t('form_please_select')" @change="onStyleTypeChange">
                    <el-option
                            class="select_item"
                            v-for="item in tableStylesList"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
    </el-form>
</template>
<script>

    export default {
        name: "spreadSet",
        props: {
            cell: Object,
            acsheet:Object,
        } ,
        watch: {
            acsheet(n,o){
                this.activeSheet=n;
                this.headerVisible=n.options.rowHeaderVisible;
                this.gridline=n.options.gridline.showVerticalGridline;
                this.tabStripVisible= this.$parent.$parent.spread.options.tabStripVisible;
            },
            cell: {

                handler(n, o) {
                    this.tableObj=null;
                    this.chartObj=null;
                    this.activeSheet=n.sheet;
                    if (n.type=="table")
                    {
                        this.fmtItem=n.sheet.getFormatter(n.row, n.col);

                        this.tableObj=n.object;
                        this.tableName=n.object.tableName();
                        this.showHeader=n.object.showHeader();
                        this.showFooter=n.object.showFooter();
                        this.showResize=n.object.showResizeHandle();
                         this.styleType=n.object.style()._ps.name;
                        this.footerDropDownList=n.object.useFooterDropDownList();
                    }
                    if (n.type=="chart")
                    {

                        this.chartObj=n.object;
                        this.cTitle=n.object.title().text;
                        this.cType=n.object.chartType();
                        //console.log( n,this.chartObj);
                          // chart.setType(10);

                    }

                },
                //deep:true// 深度监听父组件传过来对象变化
            },
        },
        data() {
            return {
                activeSheet:{},
                gridline: true,
                headerVisible:true,
                tabStripVisible:true,
                fmtList:["0.00","#,##0.00","[=0]#;###0.00000","[=0]#;#,##0.00" ,"_($* #,##0.00_);_($* (#,##0.00);_($* '-'??_);_(@_)","yyyy-MM-dd","yyyy-MM-dd hh:mm","h:mm:ss AM/PM","@","General"],
                tableStylesList: {
                    0: "Light1",
                    1: "Light2",
                    2: "Light3",
                    3: "Light4",
                    4: "Light5",
                    5: "Light6",
                    6: "Light7",
                    7: "Light8",
                    8: "Light9",
                    9: "Light10",
                    10: "Light11",
                    11: "Light12",
                    12: "Light13",
                    13: "Light14",
                    14: "Light15",
                    15: "Light16",
                    16: "Light17",
                    17: "Light18",
                    18: "Light19",
                    19: "Light20",
                    20: "Light21",
                    21: "Medium1",
                    22: "Medium2",
                    23: "Medium3",
                    24: "Medium4",
                    25: "Medium5",
                    26: "Medium6",
                    27: "Medium7",
                    28: "Medium8",
                    29: "Medium9",
                    30: "Medium10",
                    31: "Medium11",
                    32: "Medium12",
                    33: "Medium13",
                    34: "Medium14",
                    35: "Medium15",
                    36: "Medium16",
                    37: "Medium17",
                    38: "Medium18",
                    39: "Medium19",
                    40: "Medium20",
                    41: "Medium21",
                    42: "Medium22",
                    43: "Medium23",
                    44: "Medium24",
                    45: "Medium25",
                    46: "Medium26",
                    47: "Medium27",
                    48: "Medium28",
                    49: "Dark1",
                    50: "Dark2",
                    51: "Dark3",
                    52: "Dark4",
                    53: "Dark5",
                    54: "Dark6",
                    55: "Dark7",
                    56: "Dark8",
                    57: "Dark9",
                    58: "Dark10",
                    59: "Dark11",
                    60: "None"
                },
                cellType:"",
                cellTypeList:['checkbox','button'],
                fmtItem:"@",
                tableObj:null,
                chartObj:null,
                chartOp:{},
                cTitle:"",
                cType:0,
                cDataOrientation:false,
                showFooter:false,
                footerDropDownList:false,
                allowFilter:false,
                showHeader:false,
                showResize:false,
                tableName:"table1",
                styleType:"None",
            }
        },



        methods: {
            setgridline () {

                this.$parent.$parent.spread.getActiveSheet().options.gridline = { showVerticalGridline: this.gridline, showHorizontalGridline:this.gridline };

            },
            setheaderVisible(){
                this.$parent.$parent.spread.getActiveSheet().options.rowHeaderVisible = this.headerVisible;
                this.$parent.$parent.spread.getActiveSheet().options.colHeaderVisible = this.headerVisible;

            },
            settabStripVisible(){
                this.$parent.$parent.spread.options.tabStripVisible = this.tabStripVisible;
            },
            setFormatter(){
                this.$parent.$parent.setFormatter(this.fmtItem);
            },
            setCellType(){
                this.$parent.$parent.setCellType(this.cellType);
            },
            setChart(type){
                //console.log(this.chartObj);
                switch (type) {
                    case 'type':
                        this.chartObj.chartType(this.cType);
                        break;
                    case 'DataOrientation':
                        this.chartObj.switchDataOrientation();
                        break;
                    case 'title':
                        //console.log(this.chartObj);
                        let obj=this.chartObj;
                        let   title = obj.title();
                          title.text = this.cTitle;
                          title.fontFamily = "Cambria";
                          title.fontSize = 28;
                          title.color = "#696969";

                        obj.title( title);
                        break;

                    default:break;
                }
            },
            setTable(type){

                switch (type) {
                    case 'name':
                        this.tableObj.name( this.tableName);
                        break;
                    case 'header':
                        this.tableObj.showHeader( this.showHeader);
                        this.tableObj.style(GC.Spread.Sheets.Tables.TableThemes.dark1);
                        break;
                    case 'footer':
                        this.tableObj.showFooter( this.showFooter,false);
                        break;
                    case 'filter':
                        this.tableObj.filterButtonVisible( this.allowFilter);
                        break;
                    case 'fdpl':
                        this.tableObj.useFooterDropDownList(this.footerDropDownList);
                        break;
                    case 'resize':
                        this.tableObj.showResizeHandle(this.showResize);
                        break;

                    default:break;
                }
            },
            onStyleTypeChange() {

                    let style =GC.Spread.Sheets.Tables.TableThemes[this.styleType.toLowerCase()];
                    this.tableObj.style(style);
                    this.activeSheet.repaint();

            }
        }
    }

</script>

<style lang="scss" >

 .el-form .el-form-item .el-form-item__label{

        font-size: 9px;

}
</style>